import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 280 } }

  check() {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.request(), this.delayValue)
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }

  async request() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("slug", this.element.value)

    const response = await fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
    const html = await response.text()
    if (html) window.Turbo.renderStreamMessage(html)
  }
}
